class AtlPress extends HTMLElement {
  connectedCallback() {
    this.abort=new AbortController();
    this.addEventListener('click',event=>{
      const button=event.target.closest('[data-quote]');
      if (!button || !this.contains(button)) return;
      this.querySelectorAll('[data-quote]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      this.querySelectorAll('[data-quote-panel]').forEach(panel=>{panel.hidden=panel.dataset.quotePanel!==button.dataset.quote;});
    },{signal:this.abort.signal});
  }
  disconnectedCallback() { this.abort?.abort(); }
}
if(!customElements.get('atl-press')) customElements.define('atl-press',AtlPress);
